/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Das28EditionFormComponent from "parog-web/components/abstract/das28-edition-form";

import dayjs from "dayjs";
import baseEditionFormStyles from "parog-web/components/das28/base-edition-form/index.module.css";
import { computeDas28Cdai } from "parog-web/components/das28/utils/compute-das28";
import { computeCdaiDas28Activity } from "parog-web/components/das28/utils/compute-das28-activity";
import getAllDas28Jes from "parog-web/components/das28/utils/get-all-das28-jes";
import mostRecentJe from "parog-web/components/das28/utils/most-recent-je";
import Das28CdaiComputedJournalEvent from "parog-web/models/das28-cdai-computed-journal-event";
import { sortBy } from "parog-web/utils/sort";

interface FeelingInfos {
  medicFeeling: number;
  occurredAt: Date | undefined;
}

export default class Das28CdaiEditionFormComponent extends Das28EditionFormComponent {
  static forcDisplayName = "Calculer le CDAI";
  static fullComponentId = "das28/das28-cdai-edition-form";
  static journalEventClass = Das28CdaiComputedJournalEvent;

  currentComputeDas28Function = computeDas28Cdai;
  currentComputeDAS28Activity = computeCdaiDas28Activity;

  specificDas28Properties = ["medicFeeling", "comments"];
  baseEditionFormStyles = baseEditionFormStyles;

  journalEventProperties = [
    ...this.specificDas28Properties,
    ...this.standardJournalEventProperties,
    ...this.sharedDas28Properties
  ];

  get lastMedicFeelingInfos(): FeelingInfos {
    const lastDas28JesWithMedicFeeling = getAllDas28Jes(this.patient)
      .filter(je => je["medicFeeling"])
      .sort(sortBy("occurredAt", "desc"))[0];

    const lastJE = mostRecentJe(
      this.patient.lastPrFeelingEvaMedicDeclaredJournalEvent,
      lastDas28JesWithMedicFeeling
    );
    return {
      medicFeeling: lastJE?.["feeling"] || lastJE?.["medicFeeling"],
      occurredAt: lastJE?.occurredAt
    };
  }

  get computeDas28Activity(): string | undefined {
    return this.lastDAS28JE?.["das28Activity"];
  }

  get lastMedicFeelingJeDate(): string {
    if (
      this.lastMedicFeelingInfos.medicFeeling != undefined &&
      this.changeset.get("medicFeeling") ==
        this.lastMedicFeelingInfos.medicFeeling
    ) {
      return dayjs(this.lastMedicFeelingInfos.occurredAt).format(
        "[Dernière mesure le] DD/MM/YYYY"
      );
    }
    return "";
  }

  retrieveModel() {
    const model = super.retrieveModel();
    if (this.isNewMode) {
      model.medicFeeling = this.lastMedicFeelingInfos?.medicFeeling;
    }
    return model;
  }
}
